import { render, staticRenderFns } from "./PointCreditConfirm.vue?vue&type=template&id=179f15f2"
import script from "./PointCreditConfirm.vue?vue&type=script&lang=js"
export * from "./PointCreditConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports